module.exports = __webpack_public_path__ + "img/Arsat1.9bab9822.jpg";